import React, { useState, useEffect } from 'react';
import { CONTACT_EMAIL } from '../constants';
import './AboutModal.css';

const AboutModal = ({ isOpen, onClose }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const photos = [
      {
        src: '/assets/about/leap1.png',  // Change .png to .PNG
        caption: 'Jeffrey, April 10, 2017 - Age 12'
      },
      {
        src: '/assets/about/leap2.jpg',  // Change .jpg to .JPG
        caption: 'Jeffrey, April 14, 2019 - Age 14'
      },
      {
        src: '/assets/about/leap3.jpeg',  // This one is already correct
        caption: 'Jeffrey, April 10, 2021 - Age 16'
      }
  ];

  // Auto-rotate every 5 seconds
  useEffect(() => {
    if (!isOpen) return;
    
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % photos.length);
    }, 5000);
    
    return () => clearInterval(timer);
  }, [isOpen, photos.length]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="about-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <h2>About Where's Junior</h2>
        
        <div className="about-jeffrey">
          <div className="about-mission">
            <h3>Our Purpose</h3>
            <p>
              Jeffrey Lucas Gurmendi Marshall was our beloved son, brother, grandson, nephew, cousin, and friend.
              We lost Jeffrey to suicide in August 2024. <strong className="app-name">Where's Junior</strong> is one of the ways we celebrate his spirit, 
              keep him present in our world, and help each other engage with the grief we feel from Jeffrey's loss. We do
              this by engraving and placing stones around the world in places chosen by his family and friends.
            </p>
          </div>

          {/* Photo Carousel */}
          <div className="jeffrey-carousel">
            <div className="carousel-container">
              {photos.map((photo, index) => (
                <div
                  key={index}
                  className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                >
                  <img src={photo.src} alt={photo.caption} />
                  <div className="carousel-caption">{photo.caption}</div>
                </div>
              ))}
            </div>
            <div className="carousel-dots">
              {photos.map((_, index) => (
                <button
                  key={index}
                  className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>

          <div className="about-text">
            <p>
              The image engraved on these stones is inspired by a series of photographs of Jeffrey leaping between the same 2 boulders, year after year,
              on the stunningly beautiful Big Sur coastline.  These photos, and the stones we engrave and place with you, capture Jeffrey's joyous and adventuresome spirit.
            </p>

            <div className="example-stone-photo">
                <img src="/assets/about/stone.jpeg" alt="Example Junior Stone" />
                <p className="photo-caption">Example Stone:  Clouds Rest in Yosemite</p>
            </div>

            <p>
              When you visit a stone, we hope you are able to feel Jeffrey's spirit, filled not only with joy and adventure, 
              but also with his sense of humor, his kindness, and the love he felt for his family and friends.
            </p>
          </div>
        </div>

        <div className="about-access">
          <h3>Request Access</h3>
          <p>
            To help protect the stones, we limit access to people who knew Jeffrey or know his family. Thank you for your understanding.
          </p>
          <p>  
            With access, you'll be able to:
          </p>
          <ul>
            <li>See precise locations of Junior Stones</li>
            <li>View photos, videos and memories shared by others</li>
            <li>Record your own visits to stones</li>
            <li>Share your own memories, thoughts, photos and videos to honor Jeffrey</li>
          </ul>
          <p className="about-note">
            Access requests are reviewed by Jeffrey's family to maintain a 
            respectful and meaningful community. You'll hear back soon after 
            submitting your request.
          </p>
        </div>

        <div className="about-mission">
            <h3>Request a Stone</h3>
            <p>
                If you would like us to carve a stone for you to have, or to place a stone in a location that was special to you and
                Jeffrey, we would be honored to do so. Please reach out to us at{' '}
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
            </p>
            </div>

            <div className="about-mission">
            <h3>Missing or Damaged Stone?</h3>
            <p>
                If you can't find a stone in its location, or if the stone is damaged, please let us know at{' '}
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
                Thank you so much for helping us to honor Jeffrey's memory in this special way.
            </p>
        </div>

        <button className="close-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default AboutModal;